import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";

import { useUser } from "@/providers/context";
import { deletePlaylist, Playlist, PlaylistResponse } from "@/api";

export const useDeletePlaylist = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();

  return useMutation<
    PlaylistResponse | undefined,
    AxiosError<{ error: string }>,
    Pick<Playlist, "PlaylistId">
  >(
    async ({ PlaylistId }) => {
      if (uid) {
        return await deletePlaylist({ user_id: uid, PlaylistId });
      }
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.setQueryData(["playlists", uid], data);
        }
      },
    },
  );
};
